import {useNavigate} from "react-router-dom";

const Register = () => {

    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API || '';

    const registerUser = async (form) => {
        const elements = form.elements;
        if (elements['password'].value !== elements['confirm-password'].value) {
            alert('Les mots de passe ne correspondent pas.');
            return;
        }

        const payload = {
            firstName: elements.firstname.value,
            lastName: elements.lastname.value,
            email: elements.email.value,
            password: elements.password.value,
        };

        try {
            const res = await fetch(apiUrl + '/branduser/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (res.ok && data.success) {
                // registration OK, user should verify email
                // navigate to info page and pass the email so user can paste/verify token manually if needed
                navigate('/verify-email-info', { state: { email: payload.email } });
            } else {
                alert(data.message || 'Erreur lors de l\'inscription');
            }
        } catch (err) {
            console.error(err);
            alert('Impossible de contacter le serveur.');
        }
    }

    return <form className="form" onSubmit={async (e) => {
        e.preventDefault();
        await registerUser(e.target);
    }}>
        <div className="input-group">
            <label htmlFor="firstname">Prénom</label>
            <input required id="firstname" name="firstname" type="text"/>
        </div>
        <div className="input-group">
            <label htmlFor="lastname">Nom</label>
            <input required id="lastname" name="lastname" type="text"/>
        </div>
        <div className="input-group">
            <label htmlFor="email">Adresse e-mail</label>
            <input required id="email" name="email" type="email"/>
        </div>
        <div className="input-group">
            <label htmlFor="password">Mot de passe</label>
            <input required id="password" name="password" type="password"
                   pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                   title="Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre."/>
        </div>
        <div className="input-group">
            <label htmlFor="confirm-password">Confirmer le mot de passe</label>
            <input required id="confirm-password" name="confirm-password" type="password"/>
        </div>
        <button type="submit">Inscription</button>
    </form>
}

export default Register;